export default {
    to: "/dashboard/projects",
    order: 3,
    icon: "mdi-office-building-marker-outline",
    title: "Projects",
    disabled: false,
    value: 0,
    sublinks: [],
}
